export const SAVED_CONTENT = 'SAVED_CONTENTS';
export const ALL_SAVED_CONTENT = 'SAVED_CONTENTS/ALL';
